import { render, staticRenderFns } from "./AppealsGrid.vue?vue&type=template&id=43d89fc4&"
import script from "./AppealsGrid.vue?vue&type=script&lang=ts&"
export * from "./AppealsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./AppealsGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
